const EsLang = {
  TRANSACTIONS: "Transacciones",
  LOGOUT: "Cerrar sesión",
  EMAIL: "Correo",
  PHONE: "Teléfono",
};

export default EsLang;
